import { FirebaseError } from 'firebase/app'

/**
 * User-facing message for an error. Callable (Cloud Function) errors surface the
 * server's HttpsError message, which we author to be human-readable.
 */
export function errorMessage(
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): string {
  if (error instanceof FirebaseError) {
    return error.message
  }
  if (error instanceof Error && error.message) {
    return error.message
  }
  return fallback
}
